import React from 'react'
import { useNavigate } from 'react-router-dom'
import pb from '@/lib/pocketbase'
import { useAuthStore } from '@/stores/authStore'
import Card from '@/components/ui/Card'
import Button from '@/components/ui/Button'
import Badge from '@/components/ui/Badge'

export default function SettingsPage() {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)
  const logout = useAuthStore((s) => s.logout)

  const handleLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  const roleVariant: Record<string, 'primary' | 'blue' | 'green'> = {
    super_admin: 'primary',
    stadion: 'blue',
    anggota: 'green',
  }

  const roleLabel: Record<string, string> = {
    super_admin: 'Super Admin',
    stadion: 'Stadion',
    anggota: 'Anggota',
  }

  return (
    <div className="py-4 space-y-4">
      <Card>
        <h2 className="text-base font-bold mb-4">Profil</h2>

        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            {user?.foto ? (
              <img
                src={pb.files.getUrl(user, (Array.isArray(user.foto) ? user.foto[0] : user.foto) as string, { thumb: '100x100' })}
                alt={user.name}
                className="w-16 h-16 rounded-full object-cover"
              />
            ) : (
              <span className="text-2xl font-bold text-primary">
                {(user?.name || '?').slice(0, 2).toUpperCase()}
              </span>
            )}
          </div>
          <div>
            <h3 className="text-sm font-bold">{user?.name}</h3>
            {user?.email && <p className="text-xs text-text-secondary">{user.email}</p>}
            {user?.nbm && <p className="text-xs text-text-secondary">NBM: {user.nbm}</p>}
            {user?.role && (
              <Badge variant={roleVariant[user.role] || 'green'} className="mt-1">
                {roleLabel[user.role] || user.role}
              </Badge>
            )}
          </div>
        </div>

        <div className="space-y-2 text-sm">
          {user?.telepon && (
            <div className="flex justify-between">
              <span className="text-text-secondary">Telepon</span>
              <span>{user.telepon}</span>
            </div>
          )}
          {(user?.expand?.daerah_id as { nama?: string })?.nama && (
            <div className="flex justify-between">
              <span className="text-text-secondary">Daerah</span>
              <span>{(user?.expand?.daerah_id as { nama?: string })?.nama}</span>
            </div>
          )}
          {(user?.expand?.jabatan_id as { nama?: string })?.nama && (
            <div className="flex justify-between">
              <span className="text-text-secondary">Jabatan</span>
              <span>{(user?.expand?.jabatan_id as { nama?: string })?.nama}</span>
            </div>
          )}
        </div>
      </Card>

      <Card>
        <h2 className="text-base font-bold mb-4">Tentang Aplikasi</h2>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-text-secondary">Nama Aplikasi</span>
            <span>ISWARA Modul Kegiatan</span>
          </div>
          <div className="flex justify-between">
            <span className="text-text-secondary">Versi</span>
            <span>0.1.0</span>
          </div>
          <div className="flex justify-between">
            <span className="text-text-secondary">Periode</span>
            <span>2025-2029</span>
          </div>
          <div className="flex justify-between">
            <span className="text-text-secondary">SK No.</span>
            <span>01/SK-PWA/F/XII/2025</span>
          </div>
        </div>
      </Card>

      <Button block variant="danger" onClick={handleLogout}>
        Keluar
      </Button>

      <p className="text-center text-xs text-text-secondary">
        © {new Date().getFullYear()} ISWARA PW Jawa Timur
      </p>
    </div>
  )
}
